import { Grid2 } from "@mui/material";
import AddonDetailsStyle from "../AddonDetails/AddonDetailsStyle.module.scss";

const AddonDetails = (props) => {
  const { addonDetails, country, isSingleSite } = props;

  let currency = country === "USA" ? "$" : "₹";

  let additionalCost = 0;

  const stagingCount = addonDetails?.filter(
    (addon) => addon.addonType === "Staging"
  )[0]?.addonCount;

  const totalAddonCost = addonDetails?.reduce((total, addon) => {
    const cost =
      typeof addon.addonCost === "string"
        ? parseFloat(addon.addonCost.replace("$", ""))
        : addon.addonCost;

    // Calculate additional cost based on the slider value for "Staging"
    if (addon.addonType === "Staging") {
      switch (addon.addonCount) {
        case 15:
          if (country === "USA") {
            additionalCost = addon.addonCost + 0;
          } else {
            additionalCost = addon.addonCost + 0;
          }
          break;
        case 30:
          if (country === "USA") {
            additionalCost = addon.addonCost + 1;
          } else {
            additionalCost = addon.addonCost + 50;
          }
          break;
        case 45:
          if (country === "USA") {
            additionalCost = addon.addonCost + 2;
          } else {
            additionalCost = addon.addonCost + 100;
          }
          break;
        case 60:
          if (country === "USA") {
            additionalCost = addon.addonCost + 3;
          } else {
            additionalCost = addon.addonCost + 150;
          }
          break;
        case 75:
          if (country === "USA") {
            additionalCost = addon.addonCost + 4;
          } else {
            additionalCost = addon.addonCost + 200;
          }
          break;
        default:
          additionalCost = 0;
      }
    }

    return (
      total +
      (addon.addonType === "Staging" ? additionalCost : cost * addon.addonCount)
    );
  }, 0);

  return (
    <>
      <Grid2 className={AddonDetailsStyle.container}>
        <Grid2 className={AddonDetailsStyle.headerAddon}>
          <Grid2>Add-on</Grid2>
          <Grid2>{`${currency}${totalAddonCost.toFixed(2)} ${
            stagingCount !== 0 ? "" : "/mon"
          }`}</Grid2>
        </Grid2>
        {addonDetails
          .filter((item) => {
            if (
              item.addonType === "Additional Site" ||
              item.addonType === "Waf"
            )
              return false;
            if (!isSingleSite && item.addonType === "Performance Sites")
              return true;
            return item.addonType !== "Performance Sites";
          })
          .map((addon, index) => (
            <Grid2 key={index} className={AddonDetailsStyle.contentAddon}>
              <Grid2>{`${addon.addonType} (${addon.addonCount})`}</Grid2>
              <Grid2>
                {addon.addonType !== "Staging" &&
                  `${currency}${
                    (typeof addon.addonCost === "string"
                      ? parseFloat(addon.addonCost.replace("$", ""))
                      : addon.addonCost) * addon.addonCount
                  }/mon`}
                {addon.addonType === "Staging" &&
                  `${currency}${
                    typeof addon.addonCost === "string"
                      ? parseFloat(addon.addonCost.replace("$", ""))
                      : additionalCost
                  }`}
              </Grid2>
            </Grid2>
          ))}
        <Grid2 className={AddonDetailsStyle.noLineBlack}></Grid2>
      </Grid2>
    </>
  );
};

export default AddonDetails;
